export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-xl font-heading text-background-50 mb-4">51吃瓜在线</h3>
            <p className="text-sm leading-relaxed text-foreground-400">
              国内领先的娱乐资讯聚合平台，为你提供最新最全的吃瓜爆料内容。安全、快速、全面的娱乐资讯入口，千万吃瓜群众的共同选择。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">网站首页</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">焦点专题</a></li>
              <li><a href="#media" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">精彩视频</a></li>
              <li><a href="#cards" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">热门爆料</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">热议榜单</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">服务支持</h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">常见问答</a></li>
              <li><a href="#contact" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">投稿爆料</a></li>
              <li><a href="#app" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">APP下载</a></li>
              <li><a href="#about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">关于我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将揭晓，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800/40 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 51吃瓜在线 版权所有。本站内容仅供娱乐参考，请理性对待网络信息。
          </p>
          <p className="text-xs text-foreground-500">
            51吃瓜在线网址 | 51吃瓜在线官网 | 51吃瓜在线最新地址
          </p>
        </div>
      </div>
    </footer>
  );
}